import { render, staticRenderFns } from "./ProjectNumbers.vue?vue&type=template&id=4085ad9c&"
import script from "./ProjectNumbers.vue?vue&type=script&lang=js&"
export * from "./ProjectNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports